/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import './style.css';
import { useSelector } from 'react-redux';
import { DragHandler } from '../../pages/Tasks/DragHandler';
import { FocusMode } from "../LandingHeader/Feedback/icons/Icons";
import FocusModeSettingsModal from "../../pages/Settings/Modal/FocusModeSettingsModal";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { focusTimerFormatV3 } from "../action/utilities";

function FocusTimerWidget() {
    const [settingsModal, setSettingModal] = useState(false);
    const [todaySessions, setTodaySessions] = useState([]);
    const { focusSessions } = useSelector(state => state.focusTimer);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if(location.pathname === '/focus-mode-settings'){
            setSettingModal(true);
        }else{
            setSettingModal(false);
        }
    }, [location.pathname])

    useEffect(() => {
        setTodaySessions(focusSessions.filter(session => {
            return moment().format('L') === moment(session.startTime).format('L')
        }));
        
    }, [focusSessions])

    const startTimerHandler = (e) => {
        e.preventDefault();
        navigate('/focus-mode-settings');
    }

    const removeModal = (e) => {
        e && e.preventDefault();
        navigate(process.env.REACT_APP_ROOT);
    }

    const calcFocusedTime = () => {
        let seconds = 0;
        let pauseSeconds = 0;
        todaySessions.map((session, index) => {
            let lastPause = 0;
            session?.pauses.map(pause => {
                pauseSeconds += pause.endTime - pause.startTime;
                lastPause = pause;
            });

            seconds += (session.endTime ? session.endTime : (lastPause?.endTime ?? session.startTime)) - session.startTime;
        });

        return focusTimerFormatV3((seconds - pauseSeconds) / 1000, true);
    }

    return (
        <div className='bar widgetWrapper'>
            <div className={`dailyQuote quoteInner focus-timer`}>
                <div className="quoteContainer focus-timer-container">
                    <DragHandler />
                    <>
                        <div className='focusTimerSt'>
                            {
                                todaySessions.length > 0
                                ?
                                <div className="slectFocusOpt text-black dark:text-white2"><span className="accent-text-color" css={{
                                    opacity: '1 !important',
                                    'span': {
                                        opacity: '1 !important'
                                    }
                                }} dangerouslySetInnerHTML={{__html: calcFocusedTime()}} /> focused today...</div>
                                :
                                <div className={`slectFocusOpt gap-[10px] text-black dark:text-white2`}><FocusMode color={`var(--accent-color)`} /><span className="dark:opacity-100">Focus</span></div>
                            }
                            
                            <div className='focusStart'>
                                <button id="openFocusTimerSettings" onClick={startTimerHandler} className='startEvnt !line-height-normal btn-bg-light dark:btn-bg-dark' css={
                                    {
                                        color: 'grey',
                                        '&:hover': {
                                            background: `var(--accent-color-theme) !important`, 
                                            color: `#fff !important`
                                        }
                                    }
                                }>Start Session</button>
                            </div>
                        </div>
                        {
                            settingsModal
                            &&
                            <FocusModeSettingsModal todaySessions={todaySessions} show={true} onHide={removeModal} />
                        }
                    </>
                </div> 
            </div>
        </div>
    )
}

export default FocusTimerWidget